import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  icon: {
    width: 14,
    height: 16,
  },
}));
export default useStyles;
